module.exports = __webpack_public_path__ + "static/media/nemesis.f836fded.jpg";